var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(ref,i){
var icon = ref.icon;
var text = ref.text;
var action = ref.action;
var enabled = ref.enabled;
return _c('v-btn',{key:i,attrs:{"disabled":!enabled,"dark":"","icon":""},on:{"click":action}},[_c('v-icon',{attrs:{"alt":text}},[_vm._v(_vm._s(icon))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }